import { Component } from '@angular/core';

@Component({
  selector: '[account-todos-layout]',
  template: require('./account-todos-layout.component.pug'),
  styles: [require('./account-todos-layout.component.css').toString()],
})
export class AccountTodosLayoutComponent {
  // -------------------------------------------------------------------
  constructor() {}

  // -------------------------------------------------------------------
  ngOnInit() {}
}
